/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocationInner } from './LocationInner';
import {
    LocationInnerFromJSON,
    LocationInnerFromJSONTyped,
    LocationInnerToJSON,
} from './LocationInner';

/**
 * 
 * @export
 * @interface NotificationsValidationError
 */
export interface NotificationsValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof NotificationsValidationError
     */
    loc: Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof NotificationsValidationError
     */
    msg: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsValidationError
     */
    type: string;
}

/**
 * Check if a given object implements the NotificationsValidationError interface.
 */
export function instanceOfNotificationsValidationError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "loc" in value;
    isInstance = isInstance && "msg" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function NotificationsValidationErrorFromJSON(json: any): NotificationsValidationError {
    return NotificationsValidationErrorFromJSONTyped(json, false);
}

export function NotificationsValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loc': ((json['loc'] as Array<any>).map(LocationInnerFromJSON)),
        'msg': json['msg'],
        'type': json['type'],
    };
}

export function NotificationsValidationErrorToJSON(value?: NotificationsValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loc': ((value.loc as Array<any>).map(LocationInnerToJSON)),
        'msg': value.msg,
        'type': value.type,
    };
}

